import * as XLSX from 'xlsx-js-style';

export const readProductBook = (sheetsArray, file) => {
 const book = XLSX.read(file[0].buffer, { type: 'buffer' });
 const sheets = book.SheetNames;
 //const sheet = sheets[0];

 const products = sheetsArray
  .filter(sheet => sheets.some(leaf => leaf === sheet))
  .map(sheet => {
   const sheetToJson = XLSX.utils.sheet_to_json(book.Sheets[sheet], {
    blankrows: false
    //header: 1, raw: true, range: 1, defval: null, blankrows:false
   });

   const data = sheetToJson.filter(json => json?.area || json?.name);
   return { [sheet]: data };
  });

 //console.log(products);

 /* if (sheetToJson.length) {
    const data = sheetToJson.filter(json => json.area);
    return data;
  } */
 return products;
};
